export default {
  token: false,
  loading: true,
  mobile: false,
  show_survey_commissions: false,
  statuses: [],
  suppliers: [],
};
